var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide_page"},[_c('div',{staticClass:"content_wrapper"},[_c('div',{staticClass:"top_wrapper"},[_c('div',{staticClass:"logo"}),_vm._v(" "),_c('div',{staticClass:"music"})]),_vm._v(" "),_c('div',{staticClass:"shenzhen"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8b2716","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GuidePage.vue
// module id = null
// module chunks = 